export const GET_ORDERS_RESERVED = 'admin/orders/reserved'
